import { Injectable } from '@angular/core';
import { HttpProvider } from '../../core/common/http/http-provider.service';
import { HttpClient } from '@angular/common/http';
import { MasterDTO } from '../model/admin.entity';
import { PartnerDTO } from '../model/partner.entity';
import { GroupDTO } from '../model/group.entity';
import { CountryDTO } from '../model/country.entity';
import { TestTypeDTO } from '../model/test-type.entity';
import { AdminDataRepository } from '../../core/data/repositories/admindata.repository';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private adminDataRepository: AdminDataRepository) 
  {}

  // getInstiteLocation(instituteType: number) {
  //   return this.masterDataRepository.getInstiteLocByType(instituteType);
  // }

  // Region Get 
  getCerType() {
    return this.adminDataRepository.getCerType();
  }

  getCertificateTypeById(id:number){
    return this.adminDataRepository.getCertificateTypeById(id);
  }
  
  getElementType() {
    return this.adminDataRepository.getElementType();
  }

  getCostType() {
    return this.adminDataRepository.getCostType();
  }

  getCountry() {
    return this.adminDataRepository.getCountry();
  }
  
  getFrame() {
    return this.adminDataRepository.getFrame();
  }
  getUnmappedFrame() {
    return this.adminDataRepository.getUnmappedFrame();
  }
  getFrameById(id: number) {
    return this.adminDataRepository.getFrameById(id);
  }
  getFrameName() {
    return this.adminDataRepository.getFrameName();
  }

  getFrameMaterial() {
    return this.adminDataRepository.getFrameMaterial();
  }

  getGlassCoatingCode() {
    return this.adminDataRepository.getGlassCoatingCode();
  }

  getGlassManufacturer() {
    return this.adminDataRepository.getGlassManufacturer();
  }

  getGlassType() {
    return this.adminDataRepository.getGlassType();
  }

  getGlassUnit() {
    return this.adminDataRepository.getGlassUnit();
  }

  getMountingDirection() {
    return this.adminDataRepository.getMountingDirection();
  }
  getSupportingConstruction() {
    return this.adminDataRepository.getSupportingConstruction();
  }
  getGlassBehaviour() {
    return this.adminDataRepository.getGlassBehaviour();
  }

  getResultUnit() {
    return this.adminDataRepository.getResultUnit();
  }

  getBeadPosition() {
    return this.adminDataRepository.getBeadPosition();
  }

  getComponentCausedFailure() {
    return this.adminDataRepository.getComponentCausedFailure();
  }

  getGroup() {
    return this.adminDataRepository.getGroup();
  }

  getGroupType() {
    return this.adminDataRepository.getGroupType();
  }

  getInstitute() {
    return this.adminDataRepository.getInstitute();
  }

  getInstituteType() {
    return this.adminDataRepository.getInstituteType();
  }

  getOrganisationalUnit() {
    return this.adminDataRepository.getOrganisationalUnit();
  }

  getPartner() {
    return this.adminDataRepository.getPartner();
  }

  getPartnerType() {
    return this.adminDataRepository.getPartnerType();
  }

  getPerformanceCriteria() {
    return this.adminDataRepository.getPerformanceCriteria();
  }

  getAllPerformanceCriteria() {
    return this.adminDataRepository.getAllPerformanceCriteria();
  }
  getPrjConfidentialityLvl() {
    return this.adminDataRepository.getPrjConfidentialityLvl();
  }

  getOwnerType() {
    return this.adminDataRepository.getOwnerType();
  }

  getPrjPurpose() {
    return this.adminDataRepository.getPrjPurpose();
  }

  getPrjStatus() {
    return this.adminDataRepository.getPrjStatus();
  }

  getRegion() {
    return this.adminDataRepository.getRegion();
  }

  getStandard() {
    return this.adminDataRepository.getStandard();
  }
  getPartners() {
    return this.adminDataRepository.getPartners();
  }

  getFrameMaterials() {
    return this.adminDataRepository.getFrameMaterials();
  }

  getTestPurpose() {
    return this.adminDataRepository.getTestPurpose();
  }

  getTestType() {
    return this.adminDataRepository.getTestType();
  }

  getResultFailureReason() {
    return this.adminDataRepository.getResultFailureReason();
  }
  getTestTypeById(id:number){
    return this.adminDataRepository.getTestTypeById(id);
  }

  getStandardById(id: number) {
    return this.adminDataRepository.getStandardById(id);
  }

  getPerformanceCriteriaById(id: number) {
    return this.adminDataRepository.getPerformanceCriteriaById(id);
  }
 
  //EndRegion Get

  //Region Save
  saveCertificateType(cerType: MasterDTO) {
    return this.adminDataRepository.saveCertificateType(cerType);
  }

  saveConstructionElementType(constElementType: MasterDTO) {
    return this.adminDataRepository.saveConstructionElementType(constElementType);
  }

  saveCostType(costType: MasterDTO) {
    return this.adminDataRepository.saveCostType(costType);
  }

  saveCountry(country: CountryDTO) {
    return this.adminDataRepository.saveCountry(country);
  }
  saveFrameName(frameName: MasterDTO) {
    return this.adminDataRepository.saveFrameName(frameName);
  }
  saveFrameMaterial(frameMaterial: MasterDTO) {
    return this.adminDataRepository.saveFrameMaterial(frameMaterial);
  }

  saveGlassCoatingCode(glassCoatingCode: MasterDTO) {
    return this.adminDataRepository.saveGlassCoatingCode(glassCoatingCode);
  }

  saveGlassManufacturer(glassManufacturer: MasterDTO) {
    return this.adminDataRepository.saveGlassManufacturer(glassManufacturer);
  }

  saveGlassType(glassType: MasterDTO) {
    return this.adminDataRepository.saveGlassType(glassType);
  }

  saveGlassUnit(glassUnit: MasterDTO) {
    return this.adminDataRepository.saveGlassUnit(glassUnit);
  }

  saveResultUnit(resultUnit: MasterDTO) {
    return this.adminDataRepository.saveResultUnit(resultUnit);
  }
  saveMountingDirection(mountingDirection: MasterDTO) {
    return this.adminDataRepository.saveMountingDirection(mountingDirection);
  }
  saveSupportingConstruction(supportingConstruction: MasterDTO) {
    return this.adminDataRepository.saveSupportingConstruction(supportingConstruction);
  }
  saveGlassBehaviour(glassBehavior: MasterDTO) {
    return this.adminDataRepository.saveGlassBehaviour(glassBehavior);
  }
  saveBeadPosition(beadPosition: MasterDTO) {
    return this.adminDataRepository.saveBeadPosition(beadPosition);
  }

  saveComponentCausedFailure(ccf: MasterDTO) {
    return this.adminDataRepository.saveComponentCausedFailure(ccf);
  }

  saveGroup(group: GroupDTO) {
    return this.adminDataRepository.saveGroup(group);
  }

  saveGroupType(groupType: MasterDTO) {
    return this.adminDataRepository.saveGroupType(groupType);
  }

  saveInstitute(institute: MasterDTO) {
    return this.adminDataRepository.saveInstitute(institute);
  }

  saveInstituteType(instituteType: MasterDTO) {
    return this.adminDataRepository.saveInstituteType(instituteType);
  }

  saveOrganisationalUnit(organisationalUnit: MasterDTO) {
    return this.adminDataRepository.saveOrganisationalUnit(organisationalUnit);
  }

  savePartner(partner: PartnerDTO) {
    return this.adminDataRepository.savePartner(partner);
  }

  savePartnerType(partnerType: MasterDTO) {
    return this.adminDataRepository.savePartnerType(partnerType);
  }

  savePerformanceCriteria(performanceCriteria: MasterDTO) {
    return this.adminDataRepository.savePerformanceCriteria(performanceCriteria);
  }

  savePrjConfidentialityLvl(confidentialityLevel: MasterDTO) {
    return this.adminDataRepository.savePrjConfidentialityLvl(confidentialityLevel);
  }

  savePrjOwnerType(ownerType: MasterDTO) {
    return this.adminDataRepository.savePrjOwnerType(ownerType);
  }

  savePrjPurpose(prjPurpose: MasterDTO) {
    return this.adminDataRepository.savePrjPurpose(prjPurpose);  
  }

  savePrjStatus(prjStatus: MasterDTO) {
    return this.adminDataRepository.savePrjStatus(prjStatus);
  }

  saveRegion(region: MasterDTO) {
    return this.adminDataRepository.saveRegion(region);
  }

  saveStandard(standard: MasterDTO) {
    return this.adminDataRepository.saveStandard(standard);    
  }

  saveTstPurpose(tstPurpose: MasterDTO) {
    return this.adminDataRepository.saveTstPurpose(tstPurpose);
  }

  saveTstType(tstType: TestTypeDTO) {
    return this.adminDataRepository.saveTstType(tstType);   
  }

  saveResultFailureReason(result: MasterDTO) {
    return this.adminDataRepository.saveResultFailureReason(result);
  }

  //EndRegion Save


  //Region Put
  updateCertificateType(cerType: MasterDTO) {
    return this.adminDataRepository.updateCertificateType(cerType); 
  }

  updateConstructionElementType(constElementType: MasterDTO) {
    return this.adminDataRepository.updateConstructionElementType(constElementType); 
  }

  updateCostType(costType: MasterDTO) {
    return this.adminDataRepository.updateCostType(costType); 
  }

  updateCountry(country: CountryDTO) {
    return this.adminDataRepository.updateCountry(country); 
  }
   saveUpdateFrame(frame: MasterDTO) {
    return this.adminDataRepository.saveUpdateFrame(frame); 
  }
  updateFrameName(frameName: MasterDTO) {
    return this.adminDataRepository.updateFrameName(frameName); 
  }
  updateFrameMaterial(frameMaterial: MasterDTO) {
    return this.adminDataRepository.updateFrameMaterial(frameMaterial); 
  }

  updateGlassCoatingCode(glassCoatingCode: MasterDTO) {
    return this.adminDataRepository.updateGlassCoatingCode(glassCoatingCode); 
  }

  updateGlassManufacturer(glassManufacturer: MasterDTO) {
    return this.adminDataRepository.updateGlassManufacturer(glassManufacturer); 
  }

  updateGlassType(glassType: MasterDTO) {
    return this.adminDataRepository.updateGlassType(glassType); 
  }

  updateGlassUnit(glassUnit: MasterDTO) {
    return this.adminDataRepository.updateGlassUnit(glassUnit); 
  }

  updateResultUnit(resultUnit: MasterDTO) {
    return this.adminDataRepository.updateResultUnit(resultUnit); 
  }

  updateBeadPosition(beadPosition: MasterDTO) {
    return this.adminDataRepository.updateBeadPosition(beadPosition); 
  }
  updateMountingDirection(mountingDirection: MasterDTO) {
    return this.adminDataRepository.updateMountingDirection(mountingDirection);
  }
  updateSupportingConstruction(supportingConstruction: MasterDTO) {
    return this.adminDataRepository.updateSupportingConstruction(supportingConstruction);
  }
  updateGlassBehaviour(glassBehaviour: MasterDTO) {
    return this.adminDataRepository.updateGlassBehaviour(glassBehaviour);
  }

  updateComponentCausedFailure(CCF: MasterDTO) {
    return this.adminDataRepository.updateComponentCausedFailure(CCF); 
  }

  updateGroup(group: GroupDTO) {
    return this.adminDataRepository.updateGroup(group); 
  }

  updateGroupType(groupType: MasterDTO) {
    return this.adminDataRepository.updateGroupType(groupType); 
  }

  updateInstitute(institute: MasterDTO) {
    return this.adminDataRepository.updateInstitute(institute);      
  }

  updateInstituteType(instituteType: MasterDTO) {
    return this.adminDataRepository.updateInstituteType(instituteType); 
  }

  updateOrganisational(organisationalUnit: MasterDTO) {
    return this.adminDataRepository.updateOrganisational(organisationalUnit); 
  }

  updatePartner(partner: PartnerDTO) {
    return this.adminDataRepository.updatePartner(partner);  
  }

  updatePartnerType(partnerTYpe: MasterDTO) {
    return this.adminDataRepository.updatePartnerType(partnerTYpe);   
  }

  updatePerformanceCriteria(performanceCriteria: MasterDTO) {
    return this.adminDataRepository.updatePerformanceCriteria(performanceCriteria); 
  }

  updateConfidentialityLvl(confidentialityLevel: MasterDTO) {
    return this.adminDataRepository.updateConfidentialityLvl(confidentialityLevel); 
  }

  updateOwnerType(ownerType: MasterDTO) {
    return this.adminDataRepository.updateOwnerType(ownerType); 
  }

  updatePrjPurpose(prjPurpose: MasterDTO) {
    return this.adminDataRepository.updatePrjPurpose(prjPurpose);    
  }

  updatePrjStatus(prjStatus: MasterDTO) {
    return this.adminDataRepository.updatePrjStatus(prjStatus);    
  }

  updateRegion(region: MasterDTO) {
    return this.adminDataRepository.updateRegion(region); 
  }

  updateStandard(standard: MasterDTO) {
    return this.adminDataRepository.updateStandard(standard); 
  }

  updateTstPurpose(tstPurpose: MasterDTO) {
    return this.adminDataRepository.updateTstPurpose(tstPurpose); 
  }

  updateTstType(tstType: TestTypeDTO) {
    return this.adminDataRepository.updateTstType(tstType); 
  }

  updateResultFailureReason(result: MasterDTO) {
    return this.adminDataRepository.updateResultFailureReason(result); 
  }

  //EndRegion Put


  //Region Delete

  deleteCertificateType(id: number) {
    return this.adminDataRepository.deleteCertificateType(id); 
  }

  deleteConstructionElementType(id: number) {
    return this.adminDataRepository.deleteConstructionElementType(id); 
  }

  deleteCostType(id: number) {
    return this.adminDataRepository.deleteCostType(id); 
  }

  deleteCountry(id: number) {
    return this.adminDataRepository.deleteCountry(id); 
  }
  deleteFrame(id: number) {
    return this.adminDataRepository.deleteFrame(id); 
  }
  deleteFrameName(id: number) {
    return this.adminDataRepository.deleteFrameName(id); 
  }
  deleteFrameMaterial(id: number) {
    return this.adminDataRepository.deleteFrameMaterial(id); 
  }

  deleteGlassCoatingCode(id: number) {
    return this.adminDataRepository.deleteGlassCoatingCode(id); 
  }

  deleteGlassManufacturer(id: number) {
    return this.adminDataRepository.deleteGlassManufacturer(id); 
  }

  deleteGlassType(id: number) {
    return this.adminDataRepository.deleteGlassType(id); 
  }

  deleteGlassUnit(id: number) {
    return this.adminDataRepository.deleteGlassUnit(id); 
  }

  deleteResultUnit(id: number) {
    return this.adminDataRepository.deleteResultUnit(id); 
  }
  deleteBeadPosition(id: number) {
    return this.adminDataRepository.deleteBeadPosition(id); 
  }
  deleteMountingDirection(id: number) {
    return this.adminDataRepository.deleteMountingDirection(id);
  }
  deletesupportingConstruction(id: number) {
    return this.adminDataRepository.deletesupportingConstruction(id);
  }
  
  deleteGlassBehaviour(id: number) {
    return this.adminDataRepository.deleteGlassBehaviour(id);
  }

  deleteCompomemtCausedFailure(id: number) {
    return this.adminDataRepository.deleteCompomemtCausedFailure(id); 
  }


  deleteGroup(id: number) {
    return this.adminDataRepository.deleteGroup(id); 
  }

  deleteGroupType(id: number) {
    return this.adminDataRepository.deleteGroupType(id); 
  }

  deleteInstitute(id: number) {
    return this.adminDataRepository.deleteInstitute(id);     
  }

  deleteInstituteType(id: number) {
    return this.adminDataRepository.deleteInstituteType(id); 
  }

  deleteOrganisational(id: number) {
    return this.adminDataRepository.deleteOrganisational(id); 
  }

  deletePartner(id: number) {
    return this.adminDataRepository.deletePartner(id);     
  }

  deletePartnerType(id: number) {
    return this.adminDataRepository.deletePartnerType(id);    
  }

  deletePerformanceCriteria(id: number) {
    return this.adminDataRepository.deletePerformanceCriteria(id); 
  }

  deleteConfidentialityLvl(id: number) {
    return this.adminDataRepository.deleteConfidentialityLvl(id); 
  }

  deleteOwnerType(id: number) {
    return this.adminDataRepository.deleteOwnerType(id);    
  }

  deletePrjPurpose(id: number) {
    return this.adminDataRepository.deletePrjPurpose(id);    
  }

  deletePrjStatus(id: number) {
    return this.adminDataRepository.deletePrjStatus(id);    
  }

  deleteRegion(id: number) {
    return this.adminDataRepository.deleteRegion(id); 
  }

  deleteStandard(id: number) {
    return this.adminDataRepository.deleteStandard(id);   
  }

  deleteTstPurpose(id: number) {
    return this.adminDataRepository.deleteTstPurpose(id); 
  }

  deleteTstType(id:number){
    return this.adminDataRepository.deleteTstType(id);  
  }

  deleteResultFailureReason(id: number) {
    return this.adminDataRepository.deleteResultFailureReason(id); 
  }

  //EndRegion Delete
}
